import ContentGuide from 'global/guides/ContentGuide'
import { usePlanosContext } from 'pages/Planos.context'
import { Navigate, Outlet } from 'react-router-dom'
import DataGridTransacoes from './DataGridTransacoes'
import HeaderAssinatura from './DeatalhesAssinatura'
import GridDados from './GridDados'

export default function MinhaAssinatura() {
    const { assinatura, planos, cliente } = usePlanosContext()

    if (!cliente?.myId) return <Navigate to="/planos" />

    return (
        <ContentGuide>
            <ContentGuide.Card className="flex flex-col justify-start gap-4 overflow-auto md:overflow-hidden">
                <HeaderAssinatura />
                <GridDados />
                <DataGridTransacoes />
            </ContentGuide.Card>
            <Outlet context={{ planos, assinatura, cliente }} />
        </ContentGuide>
    )
}
